import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mapI18nLanguageToApiLanguage } from './queries/language.mapper';
import { LANGUAGE_API, URL_PARAM_LANGUAGE } from '../constants/language.constants';

export function useLanguageUrlSync() {
  const { i18n } = useTranslation();
  const [, setSearchParams] = useSearchParams();

  const changeLanguage = useCallback(
    (language: string) => {
      i18n.changeLanguage(language);

      setSearchParams(
        prev => {
          const newParams = new URLSearchParams(prev);
          const apiLanguage = mapI18nLanguageToApiLanguage(language);

          if (apiLanguage === LANGUAGE_API.NORWEGIAN) {
            newParams.delete(URL_PARAM_LANGUAGE);
          } else {
            newParams.set(URL_PARAM_LANGUAGE, apiLanguage);
          }

          return newParams;
        },
        { replace: true }
      );
    },
    [i18n, setSearchParams]
  );

  return { changeLanguage };
}
